import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { User } from 'app/models2/administration/user';
import { Combo } from 'app/models2/commos/combo';
import { UserEntryRecord } from 'app/models2/human-resources/user-entry-record';
import { UtilsServiceService } from 'app/services/utils-service.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import {
  CombosConfiguration,
  HttpService,
  MessageService,
  params,
} from 'brainloper-ui';

@Component({
  selector: 'app-user-entry-record-detail',
  templateUrl: './user-entry-record-detail.component.html',
  styleUrls: ['./user-entry-record-detail.component.scss'],
})
export class UserEntryRecordDetailComponent implements OnInit {
  @Output() completeRegister = new EventEmitter<boolean>();
  @Input() edit: boolean = false;
  @Input() exit: boolean = false;
  @Input() income: boolean = false;
  @Input() bodyEdit: UserEntryRecord;

  public EndpointDictionary = EndpointDictionary;
  public formR: FormGroup;
  public movil;
  public userRegister: UserEntryRecord;
  public chipUsers: params[] = [];
  public removable: boolean = true;
  public selectable: boolean = true;

  public reloadComboUsers = new EventEmitter<any>();
  public combosConfigUsers: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: EndpointDictionary.userEntryRecord.USER_ENTRY_RECORD_COMBO,
    urlParams: [],
    label: 'Usuarios',
    selected: 0,
  };

  constructor(
    private http: HttpService,
    private utils: UtilsServiceService,
    private message: MessageService,
    private formBuilder: FormBuilder
  ) {
    this.formR = this.formBuilder.group({
      userIds: null,
      entryDate: '',
      entryTime: '',
      exitDate: '',
      exitTime: '',
      totalHours: 0,
    });
  }

  ngOnInit(): void {
    this.movil = screen.width > 600 ? false : true;
    this.income;
    this.combosConfigUsers.urlParams = [
      { id: 'isEntry', value: this.edit ? '' : this.exit ? 0 : 1 },
    ];
    if (this.edit) {
      this.startFields();
    }
  }

  async startFields() {
    this.userRegister = this.bodyEdit;

    for (let controls of Object.keys(this.formR.controls)) {
      if (this.userRegister[controls]) {
        this.formR.controls[controls].setValue(this.userRegister[controls]);
      }
    }
    this.formR.controls.userIds.setValue([this.userRegister.userId]);

    this.formR.controls.entryTime.setValue(
      this.utils.extractTime(this.userRegister.entryDate)
    );
    this.formR.controls.entryDate.setValue(
      this.utils.handlerDateToIsoString(this.userRegister.entryDate)
    );

    if (this.userRegister.exitDate) {
      this.formR.controls.exitTime.setValue(
        this.utils.extractTime(this.userRegister.exitDate)
      );
      this.formR.controls.exitDate.setValue(
        this.utils.handlerDateToIsoString(this.userRegister.exitDate)
      );
    } else {
      this.formR.controls.exitTime.setValue('');
      this.formR.controls.exitDate.setValue('');
    }
  }



  async saveRegister(userRegister?: UserEntryRecord) {
    try {
      this.message.openLoading('Cargando', 'Guardando Registro de Usuario');
      if (userRegister.entryDate)
        userRegister.entryDate = this.utils.formatDateTime(
          userRegister.entryDate,
          userRegister.entryTime
        );
      if (userRegister.exitDate)
        userRegister.exitDate = this.utils.formatDateTime(
          userRegister.exitDate,
          userRegister.exitTime
        );
      let res: UserEntryRecord;

      const endpoint = this.exit
        ? EndpointDictionary.userEntryRecord.USER_ENTRY_RECORD_EXIT
        : EndpointDictionary.userEntryRecord.CRUD_USER_ENTRY_RECORD;

      if (!this.income) {
        delete userRegister.entryTime;
        delete userRegister.exitTime;
        if (this.edit) {
          userRegister.id = this.userRegister.id;
        }
      }

      if (!this.edit) {
        res = await this.http.postDataBody(endpoint, userRegister);
      } else {
        res = await this.http.putDataBody(endpoint, userRegister);
      }

      if (res === null) {
        this.message.closeLoading();
        return;
      } else {
        setTimeout(() => {
          this.completeRegister.emit(true);
        }, 500);

        this.message.SuccessToast(`Registro guardado correctamente`);
      }
    } catch (error) {
      this.message.ErrorToast('Error guardando registro usuario');
    }
    this.message.closeLoading();
  }

  getDataComboUsers($event:Combo[]) {
    this.chipUsers = [];
    for (const user of $event) {
      this.chipUsers.push({ id: user.id.toString(), nombre: user.name });
    }
  }

  returnDataComboUsers($event: Combo[]) {
    if ($event.length === 0) {
      this.message.Warning('Advertencia', 'No existen usuarios para realizar el registro').then(() => {
        this.completeRegister.emit(false);
      });
    }
  }

  errorMessage() {
    this.message.Error('Error', 'Complete los campos');
  }

  remove(data: params) {
    const index = this.chipUsers.indexOf(data);

    if (index >= 0) {
      this.chipUsers.splice(index, 1);
    }
    this.formR.controls.userIds.setValue(
      this.chipUsers.map((chip) => parseInt(chip.id))
    );
  }
}
